

@for (method of paymentmethodOrder; track $index) {
  @if(includesPaymentmethod(method)){
    @switch (method) {
      @case ('EMAIL') {
        <div id="emailpaymentmethod" [ngClass]="colorscheme" class="paymentmethod cursor-pointer max-w-[940px] mx-auto flex flex-col rounded-lg p-6 mt-6 md:mt-[50px]">
          <div class="flex flex-row items-center justify-between" (click)="paymentForm.get('paymentmethod').setValue('EMAIL')">
            <div class="flex flex-row items-center">
              <input type="radio" class="mr-[15px]" value="'EMAIL'" [checked]="paymentForm.get('paymentmethod').value === 'EMAIL'" />
              <h2 class="font-sans">{{'paymentmethod.EMAIL' |translate}}</h2>
            </div>
            <div class="flex flex-row">
              <i class="bi bi-envelope text-3xl mt-2"></i>
            </div>
          </div>
        </div>
      }
      @case ('CREDITCARD') {
        @if (_countrycode ==='BE') {
        <div id="creditcardpaymentmethod" [ngClass]="colorscheme" class="paymentmethod cursor-pointer max-w-[940px] mx-auto flex flex-col rounded-lg p-6 mt-6 md:mt-[50px]">
          <div class="flex flex-row items-center justify-between" (click)="paymentForm.get('paymentmethod').setValue('CREDITCARD')">
            <div class="flex flex-row items-center">
              <input type="radio" class="mr-[15px]" value="'CREDITCARD'" [checked]="paymentForm.get('paymentmethod').value === 'CREDITCARD'" />
              <h2 class="font-sans">{{'paymentmethod.CREDITCARD' |translate}}</h2>
            </div>
            <div class="flex flex-row">
              <i class="bi bi-credit-card-2-front text-3xl mt-2"></i>
            </div>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
            @for (network of creditcardnetworks; track network;let i = $index) {
              <app-chip colorscheme="contrast_with_border" (click)="paymentForm.get('creditcardnetwork').setValue(network); paymentForm.get('paymentmethod').setValue('CREDITCARD')" [selected]="paymentForm.get('creditcardnetwork').value === network">
                <div class="flex flex-row items-center">
                  <span class="w-20 me-6">
                    <img class="h-5" alt="{{'logo ' + network}}" src="./assets/images/creditcardnetworks/{{network |lowercase}}.svg" />
                  </span>
                  <span>{{'creditcardnetwork.' + network | translate}}</span>
                </div>
              </app-chip>
            }
          </div>
        </div>
      }
      }
      @case ('BANCONTACT') {
        <div id="bancontactpaymentmethod" [ngClass]="colorscheme" class="paymentmethod cursor-pointer max-w-[940px] mx-auto flex flex-col rounded-lg p-6 mt-6 md:mt-[50px]">
          <div class="flex flex-row items-center justify-between" (click)="paymentForm.get('paymentmethod').setValue('BANCONTACT')">
            <div class="flex flex-row items-center">
              <input type="radio" class="mr-[15px]" value="'BANCONTACT'" [checked]="paymentForm.get('paymentmethod').value === 'BANCONTACT'" />
              <h2 class="font-sans">{{'paymentmethod.BANCONTACT' |translate}}</h2>
            </div>
            <div class="flex flex-row">
              <img class="h-[25px]" src="./assets/images/banks/bancontact-logo.svg" />
            </div>
          </div>
        </div>
      }
      @case ('IDEAL') {
        <div id="idealpaymentmethod" [ngClass]="colorscheme" class="paymentmethod cursor-pointer max-w-[940px] mx-auto flex flex-col rounded-lg p-6 mt-6 md:mt-[50px]">
          <div class="flex flex-row flex-wrap-reverse items-center justify-between" (click)="paymentForm.get('paymentmethod').setValue('IDEAL')">
            <div class="flex flex-row items-center">
              <input type="radio" class="mr-[15px]" value="'IDEAL'" [checked]="paymentForm.get('paymentmethod').value === 'IDEAL'" />
              <h2 class="font-sans">{{'paymentmethod.IDEAL' |translate}}</h2>
              
            </div>
            <div class="flex flex-col text-end md:w-auto">
              <small><img class="inline mr-2" src="./assets/images/lock.svg" />{{'checkout.pay_safely_online' | translate}}</small>
              <img class="ms-auto h-10" src="./assets/images/banks/ideal-logo.svg" />
            </div>
          </div>
        </div>
      }
      @case ('NONE') {
        <div id="emailpaymentmethod" [ngClass]="colorscheme" class="paymentmethod cursor-pointer max-w-[940px] mx-auto flex flex-col rounded-lg p-6 mt-6 md:mt-[50px]">
          <div class="flex flex-row items-center justify-between" (click)="paymentForm.get('paymentmethod').setValue('NONE')">
            <div class="flex flex-row items-center">
              <input type="radio" class="mr-[15px]" value="'NONE'" [checked]="paymentForm.get('paymentmethod').value === 'NONE'" />
              <h2 class="font-sans">{{'paymentmethod.NONE' |translate}}</h2>
            </div>
            <div class="flex flex-row">
              <i class="text-xl bi bi-currency-euro"></i>
            </div>
          </div>
          <div class="flex flex-row">
            <span>{{'checkout.other_iban_method_contact_customersupport' |translate}}</span>
          </div>
        </div>
      }
    }
  }

}


